/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteGiftItemCtrl',["$log","$scope","$anchorScroll","$rootScope","$routeParams","$window","$location", "SaleView",
        "GiftItemView","CustomerView","SaleProductView","$filter","ServiceData",
        function($log,$scope,$anchorScroll,$rootScope,$routeParams,$window,$location,SaleView,
                 GiftItemView,CustomerView,SaleProductView,$filter,ServiceData)
        {
            $scope.type = $routeParams.type;
            $scope.currentImageId =  $routeParams.imageId;
            $scope.currentServiceId =  $routeParams.serviceId;
            $scope.dd = {
                view : {
                    giftItemView : null,
                    benCustomerView : null,
                    chargePrice : 0,
                    displayAmountInput : false,
                    displayAmountInputError : false,
                    defaultCode : "2015022100070",
                    serviceView : null,
                    pageTitle : "",
                    labelGift : "bon"

                }
            }
            $scope.redirectToHomeWhenAccessIsNotGranted();
            $scope.$watch('ad.dataLoaded', function(newValue, oldValue)
            {
                if (newValue)
                {
                    if ($location.path().indexOf("/giftItem/")!=-1)
                    {
                        if ($scope.currentServiceId)
                        {
                            var service = ServiceData.getById( $scope.currentServiceId);
                            $scope.dd.view.serviceView = $scope.ad.view.categoryRootView.getServiceView(service);
                            if ($scope.dd.view.serviceView)
                            {
                                $scope.dd.view.giftItemView = new GiftItemView(null,-1);
                                $scope.dd.view.benCustomerView = new CustomerView(null,-1,$scope);
                                $scope.dd.view.giftItemView.validityDate = new Date();
                                $scope.dd.view.giftItemView.validityDate.setMonth($scope.dd.view.giftItemView.validityDate.getMonth() + $scope.ad.appAttributes.giftMonthValidity);

                                if ($scope.dd.view.serviceView.hasInternetPrice)
                                    $scope.dd.view.giftItemView.price = $scope.dd.view.serviceView.internetPrice;
                                else
                                    $scope.dd.view.giftItemView.price = $scope.dd.view.serviceView.price;
                                $scope.dd.view.giftItemView.originalPrice = $scope.dd.view.giftItemView.price;
                                $scope.dd.view.giftItemView.serviceView = $scope.dd.view.serviceView;

                            }
                            else
                                $scope.openLocation("home");

                            if ($scope.type =="delivery" && $scope.ad.appAttributes.hasGiftItemDeliveryCharge)
                                $scope.dd.view.chargePrice = $scope.ad.appAttributes.giftItemDeliveryCharge; //default

                            $scope.dd.view.pageTitle = "Bon cadeau ";

                        }
                        else
                        {
                            $scope.unactiveImagesGiftView();
                            $scope.dd.view.giftItemView = new GiftItemView(null, -1);
                            $scope.dd.view.benCustomerView = new CustomerView(null, -1, $scope);
                            $scope.dd.view.giftItemView.originalPriceSelect = 50; //default
                            $scope.dd.view.giftItemView.validityDate = new Date();
                            $scope.dd.view.giftItemView.validityDate.setMonth($scope.dd.view.giftItemView.validityDate.getMonth() +  $scope.ad.appAttributes.giftMonthValidity);
                            if ( $scope.currentImageId &&  $scope.currentImageId!='')
                            {
                                $scope.currentImage = $scope.getImagesGiftViewById( $scope.currentImageId);
                                if ($scope.currentImage)
                                {
                                    $scope.ad.msgErrorService = "";
                                    $scope.currentImage.active = true;
                                }
                                else
                                {
                                    $scope.ad.msgErrorService = "Nous sommes désolés mais ce design n'existe plus.";
                                }
                            }
                            else
                            if ($scope.type =="delivery" && $scope.ad.appAttributes.hasGiftItemDeliveryCharge)
                                $scope.dd.view.chargePrice = $scope.ad.appAttributes.giftItemDeliveryCharge; //default
                            var elm =  $("#barcode");
                            if (elm)
                                elm.JsBarcode($scope.dd.view.defaultCode,{format:"EAN",displayValue:false,fontSize:16,height: 30});
                            $scope.onCurrentGiftItemPriceChange();
                            $scope.dd.view.pageTitle = "Chèque cadeau ";
                            $scope.dd.view.labelGift = "chèque";
                        }

                        switch($scope.type) {
                            case "mail":
                                $scope.dd.view.pageTitle   = $scope.dd.view.pageTitle + "envoyé par email";
                                break;
                            case "mailPrint":
                                $scope.dd.view.pageTitle   = $scope.dd.view.pageTitle + "à imprimer";
                                break;
                            case "delivery":
                                $scope.dd.view.pageTitle   = $scope.dd.view.pageTitle + "livré chez vous";
                                break;
                        }

                    }

                }
            });

            $scope.openGiftItemDelivery = function ()
            {
                if ($scope.currentServiceId)
                    $scope.openLocation("giftItem/type/delivery/service/"+$scope.currentServiceId);
                else
                    $scope.openLocation("giftItem/type/delivery");
            }

            $scope.openGiftItemsMail = function (type)
            {
                if ($scope.currentServiceId)
                    $scope.openLocation("giftItem/type/" + type +"/service/"+$scope.currentServiceId);
                else
                    $scope.openLocation("giftItemsMail/type/" + type);
            }

            $scope.addGiftItem = function ()
            {
                if ($scope.dd.view.giftItemView)
                {
                    if (isNaN($scope.dd.view.giftItemView.originalPrice) || $scope.dd.view.giftItemView.originalPrice<5 || $scope.dd.view.giftItemView.originalPrice>1000)
                    {
                        $scope.dd.view.displayAmountInputError = true;
                        return;
                    }
                    if ($scope.ad.view.customerView && $scope.ad.customerConnected) {
                        if (!$scope.ad.view.customerView.email || $scope.ad.view.customerView.email == '') {
                            alert("Vous devez indiquer un email dans 'Mon compte'");
                            return;
                        }
                    }

                    if ($scope.type === "mail" )
                    {
                        if (!$scope.dd.view.benCustomerView.lastName || $scope.dd.view.benCustomerView.lastName === '' ||
                            !$scope.dd.view.benCustomerView.firstName || $scope.dd.view.benCustomerView.firstName === ''||
                            !$scope.dd.view.benCustomerView.email || $scope.dd.view.benCustomerView.email === ''||
                            !$scope.dd.view.giftItemView.messageTitle || $scope.dd.view.giftItemView.messageTitle === ''||
                            !$scope.dd.view.giftItemView.message || $scope.dd.view.giftItemView.message === '')
                        {
                            $scope.dd.view.displayError = true;
                            return;
                        }
                    }

                    if ($scope.type === "mailPrint")
                    {
                        if (!$scope.dd.view.giftItemView.messageTitle || $scope.dd.view.giftItemView.messageTitle === ''||
                            !$scope.dd.view.giftItemView.message || $scope.dd.view.giftItemView.message === '')
                        {
                            $scope.dd.view.displayError = true;
                            return;
                        }
                    }

                    if ($scope.ad.view.currentSaleView === null)
                    {
                        $scope.ad.view.currentSaleView = new SaleView(null,-1,null,null,$scope.ad.view);
                        $scope.ad.view.currentSaleView.isCreatedByCustomer = true;
                    }
                    if ($scope.ad.view.currentBookingView)
                    {
                        $scope.ad.view.currentBookingView.saleView = $scope.ad.view.currentSaleView;
                        $scope.ad.view.currentSaleView.bookingView = $scope.ad.view.currentBookingView;
                    }

                    var giftItemView = $scope.dd.view.giftItemView;
                    giftItemView.updatePriceHT();
                    $scope.ad.view.currentSaleView.addGiftItemView(giftItemView,true);
                    switch($scope.type) {
                        case "mail":
                            giftItemView.imageUrl = null;
                            if (giftItemView.serviceView && giftItemView.serviceView.imageDisplayed)
                                giftItemView.imageUrl = giftItemView.serviceView.imageDisplayed.url;
                            else
                                for (var i=0;i<$scope.ad.view.imagesGiftView.length&&!giftItemView.imageUrl;i++)
                                    if ($scope.ad.view.imagesGiftView[i].active)
                                        giftItemView.imageUrl =  $scope.ad.view.imagesGiftView[i].url;
                            giftItemView.editionType = "email";
                            giftItemView.customerView =$scope.dd.view.benCustomerView;
                            break;
                        case "mailPrint":
                            giftItemView.imageUrl = null;
                            if (giftItemView.serviceView && giftItemView.serviceView.imageDisplayed)
                                giftItemView.imageUrl = giftItemView.serviceView.imageDisplayed.url;
                            else
                                for (var i=0;i<$scope.ad.view.imagesGiftView.length&&!giftItemView.imageUrl;i++)
                                    if ($scope.ad.view.imagesGiftView[i].active)
                                        giftItemView.imageUrl =  $scope.ad.view.imagesGiftView[i].url;
                            giftItemView.editionType = "email";
                            break;
                        case "delivery":
                            giftItemView.editionType = "delivery";
                            $scope.ad.view.currentSaleView.setDelivery("address",true,$scope.dd.view.chargePrice);
                            break;
                    }

                    $scope.ad.view.currentSaleView.currentPayment = $scope.ad.view.currentSaleView.price;
                    $scope.ad.view.currentSaleView.customerView = $scope.ad.view.customerView;
                    $scope.openLocation("checkout");
                }
            };

            $scope.onCurrentGiftItemPriceChange = function ()
            {
                if ($scope.dd.view.giftItemView.originalPriceSelect!="-1")
                {
                    $scope.dd.view.giftItemView.originalPrice = parseInt($scope.dd.view.giftItemView.originalPriceSelect);
                    $scope.dd.view.displayAmountInput = false;
                }
                else
                {
                    $scope.dd.view.displayAmountInput = true;
                    $scope.dd.view.giftItemView.originalPrice = 50;
                    $scope.dd.view.giftItemView.originalPriceInput = 50;
                }
                $scope.dd.view.giftItemView.price = $scope.dd.view.giftItemView.originalPrice;
            }
        }
    ]);


// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteGiftItemCtrl.js